/**
 * @class ProductPreorder
 */

if (!customElements.get("product-preorder")) {
  customElements.define(
    "product-preorder",
    class ProductPreorder extends HTMLElement {
      constructor() {
        super();

        this.data = this.querySelector('script[type="application/json"]');

        this.buy_button = document.querySelector("product-form #productMainSubmit");

        this.preorder_content = this.querySelector(".preorder-content");
        this.content = {
          preorder: this.dataset.preorderContent,
          preorderButton: this.dataset.preorderButton,
          addToCart: window.variantStrings.addToCart,
        };
      }

      connectedCallback() {
        this.setupEventListeners();
      }

      setupEventListeners() {
        document.addEventListener("variant:changed", (event) => {
          const variant = event.detail.variant;
          if (!variant) return;
          this.isPreorder(variant.id);
        });

        window.addEventListener("load", () => {
          const variant_id = new URLSearchParams(window.location.search).get("variant");
          if (!variant_id) return;
          this.isPreorder(parseInt(variant_id));
        });
      }

      /**
       *
       * @param {number} variant_id
       */
      isPreorder(variant_id) {
        if (this.data) {
          const data = JSON.parse(this.data.innerHTML);
          const preorder = data.variants.find((preorder) => preorder.id === variant_id);
          if (preorder) {
            if (preorder.preorder === true && preorder.available === true) {
              this.hidePreorderContent(false);
              this.hideEstimationContent(true);
              this.isCurrentVariantPreorder(true);
              //this.updatePreorderContent(preorder.preorder_date);
              this.sendPropertiesToBuyButton(true, preorder.preorder_date);
            } else {
              this.isCurrentVariantPreorder(false);
              this.hidePreorderContent(true);
              this.hideEstimationContent(false);
              this.sendPropertiesToBuyButton(false, "");
            }
          }
        }
      }

      /**
       *
       * @param {boolean} boolean
       */
      isCurrentVariantPreorder(boolean) {
        boolean ? (this.buy_button.dataset.preorder = "true") : (this.buy_button.dataset.preorder = "false");
      }

      /**
       * @param {date} date
       */
      updatePreorderContent(date) {
        const options = { year: "numeric", month: "2-digit", day: "2-digit" };
        const formattedDate = new Date(date).toLocaleDateString("fr-FR", options);
        this.preorder_content.innerHTML = `${this.content.preorder} ${formattedDate}`;
      }

      /**
       * @param {boolean} hide
       */

      hidePreorderContent(hide = false) {
        if (hide) {
          this.preorder_content.classList.contains("hidden") ? null : this.preorder_content.classList.add("hidden");
        } else {
          this.preorder_content.classList.remove("hidden");
        }
      }

      /**
       * @param {boolean} hide
       */
      hideEstimationContent(hide = false) {
        const estimation_content = document.querySelector(".swiper-delivery-slide");
        if (!estimation_content) return;

        if (hide) {
          estimation_content.classList.contains("hidden") ? null : estimation_content.classList.add("hidden");
        } else {
          estimation_content.classList.remove("hidden");
        }
      }

      /**
       *
       * @param {boolean} send
       */
      sendPropertiesToBuyButton(send = false, date = "") {
        const properties_container = document.querySelector(".preorder-properties__container");
        if (send) {
          properties_container.innerHTML = `
          <input id="static-preorder" type="hidden" name="properties[Precommande]" value="oui">
          <input id="static-preorder-date" type="hidden" name="properties[_pre-order-date]" value="${date}">
          `;
        } else {
          properties_container.innerHTML = "";
        }
      }
    }
  );
}
